import { render, staticRenderFns } from "./tplUserWorks.vue?vue&type=template&id=75e60e1f"
import script from "./tplUserWorks.vue?vue&type=script&lang=ts"
export * from "./tplUserWorks.vue?vue&type=script&lang=ts"
import style0 from "./tplUserWorks.vue?vue&type=style&index=0&id=75e60e1f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./tplUserWorks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports